<template>
  <div class="content1">
    <div class="operate">
      <el-button class="add" @click="addBadge">新增</el-button>
      <el-button class="add" @click="editBadge">修改</el-button>
      <el-button type="danger" @click="deleteBadge">删除</el-button>
    </div>
    <div class="table_con">
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        v-loading="tableLoading"
        :height="windowHeight"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" align="center">
        </el-table-column>
        <el-table-column
          type="index"
          label="序号"
          align="center"
          min-width="60"
        >
        </el-table-column>
        <el-table-column
          prop="title"
          label="活动标题"
          align="center"
          min-width="130"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="image"
          label="活动封面"
          align="center"
          width="110"
        >
          <template slot-scope="{ row }">
            <img
              v-if="row.image"
              :src="imgUrl + row.image"
              alt=""
              style="width: 50px; height: 50px"
            />
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="isPush"
          label="是否推送封面图"
          align="center"
          width="110"
        >
          <template slot-scope="{ row }">
            <div>{{ row.isPush == 1 ? "推送" : "不推送" }}</div>
          </template>
        </el-table-column> -->
        <el-table-column
          prop="state"
          label="状态"
          align="center"
          min-width="80"
        >
          <template slot-scope="{ row }">
            <div>
              {{
                row.state == 1
                  ? "已发布"
                  : row.state == 2
                  ? "未发布"
                  : row.state == 3
                  ? "已过期"
                  : ""
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="startTime"
          label="活动开始日期"
          align="center"
          min-width="160"
        >
        </el-table-column>
        <el-table-column
          prop="endTime"
          label="活动结束日期"
          align="center"
          min-width="160"
        >
        </el-table-column>
        <el-table-column
          prop="actDescribe"
          label="活动描述"
          align="center"
          min-width="160"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="leaderName"
          label="活动组织人"
          align="center"
          min-width="100"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="num"
          label="人数上限"
          align="center"
          min-width="80"
        >
        </el-table-column>
        <!-- <el-table-column
          prop="jobDescribe"
          label="岗位描述"
          align="center"
          min-width="160"
          show-overflow-tooltip
        >
        </el-table-column> -->
        <el-table-column
          prop="requirement"
          label="报名要求"
          align="center"
          min-width="160"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="place"
          label="签到位置"
          align="center"
          min-width="160"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="signInType"
          label="签到设置"
          align="center"
          min-width="160"
        >
          <template slot-scope="{ row }">
            <div>{{ row.signInType == 1 ? "仅签到" : "签到签退" }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="departmentName"
          label="推送对象"
          align="center"
          min-width="160"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
          align="center"
          min-width="160"
        >
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination_con">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageData.page"
        :page-sizes="[20, 40, 60, 80, 100]"
        :page-size="pageData.pageSize"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
      >
      </el-pagination>
    </div>
    <el-dialog
      :title="`公益发布${title}`"
      :visible.sync="dialogVisible"
      width="70%"
      :before-close="handleClose"
    >
      <div class="dialog_content">
        <el-form
          :model="form"
          label-width="110px"
          class="demo-form-inline"
          :rules="rules"
          ref="ruleForm"
        >
          <el-row style="flex-wrap: wrap" type="flex" :gutter="20">
            <el-col :span="12">
              <el-form-item label="活动标题" prop="title">
                <el-input
                  v-model="form.title"
                  placeholder="请输入活动标题"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="起止时间" prop="date">
                <el-date-picker
                  v-model="form.date"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  style="width: 100%"
                  :picker-options="pickerOptions"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="12">
              <el-form-item label="岗位描述" prop="jobDescribe">
                <el-input
                  v-model="form.jobDescribe"
                  placeholder="请输入岗位描述"
                ></el-input>
              </el-form-item>
            </el-col> -->
            <el-col :span="12">
              <el-form-item label="活动组织人" prop="leaderNo">
                <el-cascader
                  v-model="form.leaderNo"
                  style="width: 100%"
                  :options="treeList"
                  :props="defaultProps"
                  clearable
                  collapse-tags
                  filterable
                  placeholder="请选择活动组织人"
                ></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="报名要求" prop="requirement">
                <el-input
                  v-model="form.requirement"
                  placeholder="请输入报名要求"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="签到位置一" prop="address">
                <el-input
                  v-model="form.address"
                  placeholder="请输入活动地点"
                  @input="changeAddress"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="人数上限" prop="num">
                <el-input
                  type="number"
                  v-model="form.num"
                  placeholder="请输入人数上限"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="签到位置二" prop="address1">
                <el-input
                  v-model="form.address1"
                  placeholder="请输入活动地点"
                  @input="changeAddress1"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="推送对象" prop="departmentId">
                <el-cascader
                  v-model="form.departmentId"
                  style="width: 100%"
                  :options="treeList"
                  :props="defaultProps"
                  clearable
                  collapse-tags
                  filterable
                  placeholder="请选择推送对象"
                ></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="签到设置">
                <el-radio-group v-model="form.signInType">
                  <el-radio :label="1">仅签到</el-radio>
                  <el-radio :label="2">签到签退</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="12">
              <el-form-item label="是否推送封面图">
                <el-radio-group v-model="form.isPush" @input="changeIsPush">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="2">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col> -->
            <el-col :span="12">
              <el-form-item label="活动封面" prop="iconId">
                <el-upload
                  :action="`${upload}/file/upload`"
                  list-type="picture-card"
                  :on-success="handleBeforeImage"
                  :on-remove="handleRemove"
                  :on-preview="previewBeforeImage"
                  :file-list="beforeImageList"
                  :class="{ hide: hideUpload }"
                  accept=".jpg,.jpeg,.png"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item label="活动描述" prop="actDescribe">
                <el-input
                  type="textarea"
                  :rows="3"
                  placeholder="请输入活动描述"
                  v-model="form.actDescribe"
                  maxlength="150"
                  show-word-limit
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button
          class="add"
          @click="confirmSubmit(2)"
          :disabled="isBtnDisabled"
          >保存</el-button
        >
        <el-button
          class="add"
          @click="confirmSubmit(1)"
          :disabled="isBtnDisabled"
          >提交</el-button
        >
      </span>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="deleteVisible" width="30%">
      <span>你确定要删除你选中的这条记录吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteVisible = false">取 消</el-button>
        <el-button class="add" @click="confirmDetele" :disabled="isBtnDisabled"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisibleImg">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import api from "@/apis/medal";
import moment from "moment";
export default {
  name: "badgeMaintain",
  data() {
    return {
      pageData: {
        page: 1,
        pageSize: 20
      },
      total: 0,
      tableData: [],
      multipleSelection: [],
      tableLoading: false,
      windowHeight: 350,
      dialogVisible: false,
      form: {
        signInType: 1,
        // isPush: 1
      },
      rules: {
        title: [{ required: true, message: "请输入活动标题", trigger: "blur" }],
        date: [
          { required: true, trigger: "change", validator: this.validateDate }
        ],
        // jobDescribe: [
        //   { required: true, message: "请输入岗位描述", trigger: "blur" }
        // ],
        leaderNo: [
          { required: true, message: "请选择活动组织人", trigger: "change" }
        ],
        requirement: [
          { required: true, message: "请输入报名要求", trigger: "blur" }
        ],
        address: [
          { required: true, message: "请输入活动地点", trigger: "blur" }
        ],
        num: [
          {
            required: true,
            trigger: "blur",
            validator: this.validateNumber
          }
        ],
        departmentId: [
          { required: true, message: "请选择推送对象", trigger: "change" }
        ],
        // iconId: [
        //   { required: true, message: "请选择活动封面", trigger: "change" }
        // ],
        actDescribe: [
          { required: true, message: "请输入活动描述", trigger: "change" }
        ]
      },
      title: "新增",
      deleteVisible: false,
      itemId: "",
      beforeImageList: [],
      dialogImageUrl: "",
      dialogVisibleImg: false,
      upload: "",
      hideUpload: false,
      imgUrl: "",
      isBtnDisabled: false,
      treeList: [],
      defaultProps: {
        children: "child",
        multiple: true,
        // checkStrictly: true,
        value: "username",
        label: "nickname",
        emitPath: false
        // expandTrigger: "hover"
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < new Date().getTime() - 86400000;
        },
        selectableRange: (() => {
          let data = new Date();
          let hour = data.getHours();
          let minute = data.getMinutes();
          let second = data.getSeconds();
          return [`${hour}:${minute}:${second} - 23:59:59`];
        })()
      }
    };
  },
  mounted() {
    this.upload = api.upload;
    this.imgUrl = api.imgUrl;
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    this.queryData();
    this.querydirectory();
  },
  // 销毁
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      // 使用 window.innerHeight 获取窗口的高度
      this.$nextTick(() => {
        this.windowHeight = window.innerHeight - 280;
      });
    },
    //校验时间
    validateDate(rule, value, callback) {
      if (!value) {
        callback(new Error("请选择起止时间"));
      } else {
        const targetDate = new Date(value[0]);
        const currentDate = new Date();
        if (targetDate < currentDate) {
          callback(new Error("开始时间不能小于当前时间"));
        } else {
          callback();
        }
      }
    },
    //校验人数上限
    validateNumber(rule, value, callback) {
      if (!value) {
        callback(new Error("请输入人数上限"));
      } else {
        value = value.toString();
        var reg = /^((?!0)\d{1,9})$/;
        if (!value.match(reg)) {
          this.form.num = null;
          callback(new Error("人数上限请输入正整数"));
        } else {
          callback();
        }
      }
    },
    queryParams() {
      this.queryData();
    },
    //重置查询条件
    handleReset() {
      this.query = {
        medalName: "",
        medalTypeId: "",
        status: ""
      };
      this.queryData();
    },
    //导出
    handleExport() {
      this.$refs.exportDialog.dialogVisible = true;
    },
    // 选择table
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //分页
    handleSizeChange(val) {
      this.pageData.pageSize = val;
      this.queryData();
    },
    //页码
    handleCurrentChange(val) {
      this.pageData.page = val;
      this.queryData();
    },
    //取消新增编辑弹框
    handleClose() {
      this.dialogVisible = false;
      this.$refs.ruleForm.resetFields();
      this.itemId = "";
      this.beforeImageList = [];
    },
    // 显示 新增
    addBadge() {
      this.title = "新增";
      this.form = {
        signInType: 1,
        // isPush: 1
      };
      // this.form.medalTypeId=''
      this.hideUpload = false;
      this.dialogVisible = true;
      this.$refs.ruleForm?.resetFields();
    },
    //显示 编辑
    editBadge() {
      if (this.multipleSelection.length == 1) {
        this.form = {
          medalTypeId: this.multipleSelection[0].medalTypeId,
          title: this.multipleSelection[0].title,
          // jobDescribe: this.multipleSelection[0].jobDescribe,
          leaderNo: this.multipleSelection[0].leaderNo.split(","),
          requirement: this.multipleSelection[0].requirement,
          num: this.multipleSelection[0].num,
          departmentId: this.multipleSelection[0].departmentId.split(","),
          signInType: Number(this.multipleSelection[0].signInType),
          iconId: this.multipleSelection[0].image,
          // isPush: Number(this.multipleSelection[0].isPush),
          actDescribe: this.multipleSelection[0].actDescribe,
          date: [
            new Date(this.multipleSelection[0].startTime),
            new Date(this.multipleSelection[0].endTime)
          ]
        };

        const place = this.multipleSelection[0].place.split(",");
        this.form.address = place[0];
        if (place[1]) {
          this.form.address1 = place[1];
        }
        this.itemId = this.multipleSelection[0].id;
        this.form.id = this.multipleSelection[0].id;
        if (this.multipleSelection[0].image) {
          this.beforeImageList = [
            {
              url: api.imgUrl + this.multipleSelection[0].image,
              isImage: true
            }
          ];
          this.hideUpload = true;
        } else {
          this.hideUpload = false;
        }
        this.title = "编辑";
        this.dialogVisible = true;
      } else if (this.multipleSelection.length > 1) {
        return this.$message({
          message: "请选择一条内容进行编辑",
          type: "warning"
        });
      } else {
        return this.$message({
          message: "请选择需要编辑的内容",
          type: "warning"
        });
      }
    },
    // 确认新增 编辑
    confirmSubmit(state) {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          const json = {
            title: this.form.title,
            // jobDescribe: this.form.jobDescribe,
            leaderNo: this.form.leaderNo.toString(),
            requirement: this.form.requirement,
            num: this.form.num,
            departmentId: this.form.departmentId.toString(),
            signInType: this.form.signInType,
            image: this.form.iconId,
            // isPush: this.form.isPush,
            actDescribe: this.form.actDescribe,
            state
          };
          if (this.form.address1) {
            json.place = this.form.address + "," + this.form.address1;
          } else {
            json.place = this.form.address;
          }
          if (this.form.date.length > 0) {
            json.startTimeStr = moment(this.form.date[0]).format(
              "YYYY-MM-DD HH:mm:ss"
            );
            json.endTimeStr = moment(this.form.date[1]).format(
              "YYYY-MM-DD HH:mm:ss"
            );
          }
          if (this.title == "编辑") {
            json.id = this.multipleSelection[0].id;
          }
          this.isBtnDisabled = true;
          api
            .addPubBenefit(json)
            .then(res => {
              if (res.code == 200) {
                this.$message({
                  message: this.title + "成功",
                  type: "success"
                });
                this.itemId = "";
                this.isBtnDisabled = false;
                this.dialogVisible = false;
                this.beforeImageList = [];
                this.queryData();
              }
            })
            .catch(() => {
              this.isBtnDisabled = false;
            });
        } else {
          return false;
        }
      });
    },
    // 显示 删除弹框
    deleteBadge() {
      if (this.multipleSelection.length == 1) {
        this.deleteVisible = true;
      } else if (this.multipleSelection.length > 1) {
        return this.$message({
          message: "请选择一条内容进行删除",
          type: "warning"
        });
      } else {
        return this.$message({
          message: "请选择需要删除的内容",
          type: "warning"
        });
      }
    },
    //确认删除
    confirmDetele() {
      this.isBtnDisabled = true;
      api
        .deletePubBenefitApi({ activityId: this.multipleSelection[0].id })
        .then(res => {
          if (res.code == 200) {
            this.$message({
              message: "删除成功",
              type: "success"
            });
            this.isBtnDisabled = false;
            this.deleteVisible = false;
            this.queryData();
          }
        })
        .catch(() => {
          this.isBtnDisabled = false;
        });
    },

    // 查询 列表
    queryData() {
      const json = {
        ...this.pageData
        // ...this.query
      };
      this.tableLoading = true;
      api
        .queryPubBenefitApi(json)
        .then(res => {
          if (res.code == 200) {
            this.tableData = res.data.list.map(item => {
              item.startTime = moment(item.startTime).format(
                "YYYY-MM-DD HH:mm:ss"
              );
              item.endTime = moment(item.endTime).format("YYYY-MM-DD HH:mm:ss");
              item.createTime = moment(item.createTime).format(
                "YYYY-MM-DD HH:mm:ss"
              );
              return item;
            });
            this.total = res.data.total;
          }
          this.tableLoading = false;
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },

    //上传
    handleBeforeImage(file) {
      this.hideUpload = true;
      this.form.iconId = file.id;
      this.$refs.ruleForm.clearValidate("iconId");
    },
    //删除
    handleRemove() {
      this.form.iconId = "";
      this.hideUpload = false;
    },
    // 图片放大预览
    previewBeforeImage(file) {
      this.dialogImageUrl = file.response
        ? api.imgUrl + file.response.id
        : file.url;
      // this.dialogImageUrl = file.url;
      this.dialogVisibleImg = true;
    },
    //获取活动组织人
    querydirectory() {
      api.directory().then(data => {
        if (data.code == 200) {
          this.treeList = data.data;
        }
      });
    },
    //签到位置1
    changeAddress() {
      this.$forceUpdate();
    },
    //签到位置2
    changeAddress1() {
      this.$forceUpdate();
    },
    //活动时间，开始时间不能小于当前时间
    changePicker() {
      const targetDate = new Date(this.form.date[0]);
      const currentDate = new Date();
      if (targetDate < currentDate) {
        this.form.date = [];
        this.$message({
          type: "warning",
          message: "开始时间不能小于当前时间",
          duration: 1000
        });
      }
    },
    //是否推送封面图
    changeIsPush() {
      if (this.form.isPush == 2) {
        this.form.iconId = null;
        this.beforeImageList = [];
        this.hideUpload = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.content1 {
  background-color: #f2fcf9;
  // height: 100%;
  .query_con {
    // margin: 30px 40px 20px 40px;
    padding: 40px 0 0px 40px;
    // border: 1px solid #e5e5e5;
    border-radius: 5px;
    ::v-deep {
      .el-date-editor .el-range-separator {
        padding: 0 28px;
      }
    }
    .add {
      color: #fff;
      background-color: #23c0d8;
      border-color: #23c0d8;
    }
  }
  .operate {
    margin: 20px 40px;
    .add {
      color: #fff;
      background-color: #23c0d8;
    }
  }
  .table_con {
    background-color: #fff;
    border: 1px solid #e2e6e5;
    padding: 40px 20px;
    margin: 0 40px;
    border-radius: 5px;
  }
  .pagination_con {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-top: 30px;
    padding-right: 40px;
  }
  .dialog-footer {
    .add {
      color: #fff;
      background-color: #23c0d8;
    }
  }
  ::v-deep .hide .el-upload--picture-card {
    display: none;
  }
}
.form_hint {
  margin-top: 10px;
  font-size: 20px;
  color: #c9554b;
  line-height: 25px;
}
::v-deep {
  .el-date-editor .el-range-separator {
    width: 30px;
  }
  .el-radio__input.is-checked + .el-radio__label {
    color: #606266;
  }
  .el-radio__input.is-checked .el-radio__inner {
    background-color: #fff;
  }
  .el-radio__inner::after {
    width: 13px;
    height: 13px;
    background-color: #1684fc;
  }
}
</style>
